<template>
  <topHeader />
  <div class='product-detail'>
    
    <div class="container">
    <!-- 面包屑导航 -->
    <!-- <div class='breadcrumb'>
      <span>我要找土</span>
      <span>></span>
      <span>昌黎县</span>
      
    </div> -->
    </div>
    <!-- 主要内容区域 -->
    <div class='container'>
      <!-- 左侧图片区域 -->
      <div class='image-section'>
        <div class='main-image'>
          <img :src='currentImage' alt='土图片' class='detail-img'>
          <div class='status-tag' v-if="isFromSuccess">已利用</div>
          <div class='status-tag' v-else>待利用</div>
          <!-- <div class='image-nav'>
            <span class='nav-arrow left-arrow'>‹</span>
            <span class='nav-arrow right-arrow'>›</span>
          </div> -->
          
        </div>
        <div class='image-thumbnails'>
          <div 
            class='thumbnail'
            :class="{ active: index === currentImageIndex }"
            v-for='(img, index) in product.images'
            :key='index'
            @click='selectThumb(index)'
          >
            <img :src='img' alt='缩略图'>
          </div>
        </div>
      </div>
      
      <!-- 右侧详情区域 ---弃土找土-->
      <div class='detail-section' v-if="!isFromSuccess">
        <!-- 标题区域 -->
        <div class='title-section'>
          <h1 class='detail-title'>{{ product.title || '土方详情' }}</h1>
          <div class='detail-meta'>
            <div class='meta-left'>
              <span class='update-time'>更新时间: 2025-9-17 16:53:37</span>
              <span class='view-count'>{{product.viewCount || 0}} 次查看</span>
            </div>
            <div class='meta-actions' >
               <button class='view-phone-btn' @click="addSoilApply"> 请求匹配 </button>
             <!-- <button class='view-phone-btn' > 编辑 </button> -->
            </div>
          </div>
          <!-- <div class='action-icons'>
            <span class='action-icon'>举报</span>
            <span class='action-icon'>收藏</span>
            <span class='action-icon'>分享</span>
          </div> -->
        </div>
        
        <!-- 土属性 -->
          <div class='land-attributes'>
          <div class='attribute-item'>
            <span class='attr-label'>土方地点:</span>
            <span class='attr-value'>{{ product.address || '—' }}</span>
          </div>
          <div class='attribute-item'>
            <span class='attr-label'>土方类型:</span>
            <span class='attr-value'>{{ product.soilType || '—' }}</span>
          </div>
          <!-- <div class='attribute-item'>
            <span class='attr-label'>流转类型</span>
            <span class='attr-value'>使用权出租</span>
          </div>
          <div class='attribute-item'>
            <span class='attr-label'>流转年限</span>
            <span class='attr-value'>20年</span>
          </div> -->
          <div class='attribute-item'>
            <span class='attr-label'>土方体积:</span>
            <span class='attr-value'>{{ (product.volume || 0) + (product.volumeUnit || '') }}</span>
          </div>
          <div class='attribute-item'>
            <span class='attr-label'>联系方式:</span>
              <div class='attr-value-group'>
                <span class='attr-value'>{{ displayPhone }}</span>
                <button class='view-phone-btn' @click="togglePhoneDisplay" :disabled="contactLoading">
                  {{ contactLoading ? '加载中...' : (showFullPhone ? '隐藏' : '查看') }}
                </button>
              </div>
          </div>
          <div class='attribute-item'>
            <span class='attr-label'>详细描述:</span>
            <span class='attr-value'>{{ (product.detail || '—') }}</span>
          </div>
        </div>
        
      
      </div>

      <!-- 右侧详情区域 ---成功案例-->
      <div class='detail-section' v-if="isFromSuccess">
        <!-- 标题区域 -->
        <div class='title-section'>
          <h1 class='detail-title'>{{ product.title  }}</h1>
          <div class='detail-meta'>
            <div class='meta-left'>
              <span class='update-time'>审核时间: {{ product.processTime || product.updateTime || '—' }}</span>
              <span class='view-count'>{{ product.viewCount || 0 }} 次浏览</span>
            </div>
            <div class='meta-actions' >
               <!-- <button class='view-phone-btn' > 请求匹配 </button> -->
             <!-- <button class='view-phone-btn' > 编辑 </button> -->
            </div>
          </div>
          <!-- <div class='action-icons'>
            <span class='action-icon'>举报</span>
            <span class='action-icon'>收藏</span>
            <span class='action-icon'>分享</span>
          </div> -->
        </div>
        
        <!-- 土属性 -->
          <div class='land-attributes'>
            <div class='attribute-item'>
              <span class='attr-label'>供土方建设单位:</span>
              <span class='attr-value'>{{ product.supplyUnit || '—' }}</span>
            </div>
            <div class='attribute-item'>
              <span class='attr-label'>用土方建设单位:</span>
              <span class='attr-value'>{{ product.demandUnit || '—' }}</span>
            </div>
            <div class='attribute-item'>
              <span class='attr-label'>关联项目名称:</span>
              <span class='attr-value'>{{ product.projectName || '—' }}</span>
            </div>
            <div class='attribute-item'>
              <span class='attr-label'>供用土期限:</span>
              <span class='attr-value'>{{ formatSupplyPeriod(product.startTime, product.endTime, product.earthworkPeriod) }}</span>
            </div>
            <div class='attribute-item'>
              <span class='attr-label'>土方地点:</span>
              <span class='attr-value'>{{ product.address || '—' }}</span>
            </div>
            <div class='attribute-item'>
              <span class='attr-label'>土方类型:</span>
              <span class='attr-value'>{{ product.soilType || '—' }}</span>
            </div>
          <div class='attribute-item'>
            <span class='attr-label'>土方量:</span>
            <span class='attr-value'>{{ formatVolume(product.volume, product.volumeUnit) }}</span>
          </div>
          <div class='attribute-item'>
            <span class='attr-label'>减少水土流失量:</span>
            <span class='attr-value'>{{ product.soilLossReduction != null && product.soilLossReduction !== '' ? product.soilLossReduction : '—' }}</span>
          </div>
          <!-- <div class='attribute-item'>
            <span class='attr-label'>土方体积</span>
            <span class='attr-value'>{{ (product.volume || 0) + (product.volumeUnit || '') }}</span>
          </div> -->
          <!-- <div class='attribute-item'>
            <span class='attr-label'>联系方式</span>
              <div class='attr-value-group'>
                <span class='attr-value'>{{ displayPhone }}</span>
                <button class='view-phone-btn' @click="togglePhoneDisplay" :disabled="contactLoading">
                  {{ contactLoading ? '加载中...' : (showFullPhone ? '隐藏' : '查看') }}
                </button>
              </div>
          </div> -->
          <div class='attribute-item'>
            <span class='attr-label'>详细描述:</span>
            <span class='attr-value'>{{ (product.detail || '—') }}</span>
          </div>
        </div>
        
      
      </div>


    </div>

    <!-- 地图位置区域 -->
    <div class='map-section '>
      <div class='map-header'>
        <h3 class='map-title'>
          <span class='iconfont icon-dingwei'></span>
          土方位置
        </h3>
        <span class='map-address'>{{ product.address || '—' }}</span>
      </div>
      <div class='map-container'>
        <div id='product-map' class='product-amap'></div>
      </div>
      <!-- <div class='map-actions'>
        <button class='map-btn'>
          <span class='iconfont icon-daohang'></span>
          导航到这里
        </button>
        <button class='map-btn'>
          <span class='iconfont icon-fenxiang'></span>
          分享位置
        </button>
      </div> -->
    </div>

    <!-- 请求匹配弹窗 -->
    <div v-if="showRequestMatchModal" class="request-match-modal" @click.self="closeRequestMatchModal">
      <div class="request-match-modal-content">
        <div class="request-match-modal-header">
          <h3>匹配申请</h3>
          <button class="close-btn" @click="closeRequestMatchModal">×</button>
        </div>
        <div class="request-match-modal-body">
          <div class="soil-type-selector">
            <div class="selector-label">请选择土方类型：</div>
            <div class="radio-group">
              <label class="radio-option">
                <input 
                  type="radio" 
                  value="1" 
                  v-model="selectedSoilType"
                  @change="onSoilTypeChange"
                />
                <span>找土</span>
              </label>
              <label class="radio-option">
                <input 
                  type="radio" 
                  value="2" 
                  v-model="selectedSoilType"
                  @change="onSoilTypeChange"
                />
                <span>弃土</span>
              </label>
            </div>
          </div>
          <div v-if="unmatchedListLoading" class="loading-text">加载中...</div>
          <div v-else-if="unmatchedList.length === 0" class="empty-text">暂无可匹配的土方信息</div>
          <div v-else class="unmatched-list">
            <div 
              v-for="item in unmatchedList" 
              :key="item.id"
              class="unmatched-item"
              :class="{ active: selectedUnmatchedId === item.id }"
              @click="selectedUnmatchedId = item.id"
            >
              <div class="unmatched-radio">
                <input 
                  type="radio" 
                  :id="'unmatched-' + item.id"
                  :value="item.id"
                  v-model="selectedUnmatchedId"
                />
                <label :for="'unmatched-' + item.id"></label>
              </div>
              <div class="unmatched-info">
                <div class="unmatched-title">{{ item.title || '未命名' }}</div>
                <div class="unmatched-details">
                  <div class="unmatched-detail-item" v-if="item.address">
                    <span class="detail-label">地点:</span>
                    <span class="detail-value">{{ item.address }}</span>
                  </div>
                  <div class="unmatched-detail-item" v-if="item.volume">
                    <span class="detail-label">土方量:</span>
                    <span class="detail-value">{{ item.volume }}{{ item.volumeUnit || '立方' }}</span>
                  </div>
                  <div class="unmatched-detail-item" v-if="item.soilType">
                    <span class="detail-label">土方类型:</span>
                    <span class="detail-value">{{ item.soilType }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="request-match-modal-footer">
          <button class="cancel-btn" @click="closeRequestMatchModal">取消</button>
          <button class="submit-btn" @click="submitRequestMatch" :disabled="!selectedSoilType || !selectedUnmatchedId || unmatchedListLoading">提交</button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Toast 提示框 -->
  <transition name="toast-fade">
    <div v-if="showToast" class="success-toast">
      <div class="toast-content" :class="{ 'toast-error': toastType === 'error' }">
        <span class="toast-icon" v-if="toastType === 'success'">✓</span>
        <span class="toast-icon toast-error-icon" v-else>✕</span>
        <span class="toast-message">{{ toastMessage }}</span>
      </div>
    </div>
  </transition>
  
  <Footer />
</template>

<script>
import TopHeader from './top-Header.vue'
import Footer from './Footer.vue'
import { getWebInfoDetail, addSoilApply,getMySoilInfoSmartUnmatched,getWebSuccessCaseDetail } from '@/api/user'
import { getContactInfo } from '@/api/soil'

export default {
  name: 'ProductDetail',
  components: {
    TopHeader,
    Footer
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      product: {
        id: '',
        viewCount: 0,
        image: require('@/assets/sjt/1.png'),
        images: [],
        title: '',
        volume: 0,
        volumeUnit: '',
        address: '',
        soilType: '',
        contactPhone: '',
        longitude: null,
        latitude: null,
        detail: '',
        // 成功案例特有字段
        supplyUnit: '',
        demandUnit: '',
        projectName: '',
        startTime: '',
        endTime: '',
        earthworkPeriod: '',
        soilLossReduction: '',
        updateTime: '',
        processTime: ''
      },
      map: null,
      // 昌黎县的坐标 (随机选择昌黎县内的一个位置)
      landLocation: {
        lng: 119.18,
        lat: 39.73
      },
      currentImageIndex: 0,
      showFullPhone: false, // 是否显示完整手机号
      contactLoading: false, // 是否正在加载联系方式
      // 请求匹配弹窗相关
      showRequestMatchModal: false,
      unmatchedList: [],
      selectedUnmatchedId: null,
      unmatchedListLoading: false,
      selectedSoilType: '', // 选中的土方类型：'1'找土，'2'弃土
      // Toast 提示相关
      showToast: false,
      toastMessage: '',
      toastType: 'success' // 'success' 或 'error'
    }
  },
  computed: {
    currentImage() {
      if (this.product && Array.isArray(this.product.images) && this.product.images.length > 0) {
        return this.product.images[this.currentImageIndex] || this.product.images[0]
      }
      return this.product.image
    },
    // 判断是否从成功案例进入
    isFromSuccess() {
      return this.$route.query && this.$route.query.from === 'success'
    },
    // 判断是否显示编辑和下架按钮（只有 id 为 9 时显示）
    showEditButtons() {
      const currentId = String(this.id || this.product.id || '');
      return currentId === '9' || Number(currentId) === 9;
    },
    // 显示手机号（加密或完整）
    displayPhone() {
      const phone = this.product.contactPhone;
      if (!phone) return '—';
      if (this.showFullPhone) {
        return phone;
      }
      // 加密显示（如 173****2749）
      const p = String(phone);
      if (p.length >= 7) {
        const start = p.slice(0, 3);
        const end = p.slice(-4);
        return `${start}****${end}`;
      }
      if (p.length > 2) {
        return p[0] + '*'.repeat(Math.max(1, p.length - 2)) + p[p.length - 1];
      }
      return p;
    }
  },
  methods: {
    formatSupplyPeriod(start, end, earthworkPeriod) {
      if (earthworkPeriod) return earthworkPeriod;
      const fmt = (v) => {
        if (v == null || v === '') return '';
        const s = String(v).trim();
        if (/^\d{4}-\d{2}$/.test(s)) {
          const [y, m] = s.split('-');
          return `${y}年${m}月`;
        }
        const d = new Date(s);
        if (!Number.isNaN(d.getTime())) {
          return `${d.getFullYear()}年${String(d.getMonth() + 1).padStart(2, '0')}月${String(d.getDate()).padStart(2, '0')}日`;
        }
        return s;
      };
      const a = fmt(start);
      const b = fmt(end);
      if (!a && !b) return '—';
      if (a && b) return `${a} 至 ${b}`;
      return a || b;
    },
    formatVolume(volume, unit) {
      if (volume == null || volume === '') return '—';
      return `${volume}${unit || '立方米'}`;
    },
    parseSuccessCaseDetail(res, id) {
      if (!res) return null;
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && res.data.id != null) {
        return res.data;
      }
      let list = [];
      if (res.rows && Array.isArray(res.rows)) {
        list = res.rows;
      } else if (res.data?.rows && Array.isArray(res.data.rows)) {
        list = res.data.rows;
      } else if (Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res)) {
        list = res;
      }
      return list.find(item => String(item.id) === String(id)) || list[0] || null;
    },
    mapSuccessCaseProduct(d) {
      const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
      const allFileNames = typeof d.imageUrl === 'string'
        ? d.imageUrl.split(',').map(s => s.trim()).filter(Boolean)
        : [];
      const allImgs = allFileNames.map(fn => (fn.startsWith('http') ? fn : imageBaseUrl + fn));
      const firstImg = allImgs[0] || '';
      return {
        id: d.id,
        viewCount: d.viewCount || 0,
        image: firstImg || this.product.image,
        images: allImgs.length > 0 ? allImgs : [firstImg || this.product.image],
        title: d.projectName || d.title || '',
        volume: d.volume ?? 0,
        volumeUnit: d.volumeUnit || '立方米',
        address: d.address || '',
        soilType: d.soilType || '',
        contactPhone: d.contactPhone || '',
        longitude: d.longitude || null,
        latitude: d.latitude || null,
        detail: d.detail || '',
        supplyUnit: d.supplyUnit || '',
        demandUnit: d.demandUnit || '',
        projectName: d.projectName || '',
        startTime: d.startTime || '',
        endTime: d.endTime || '',
        earthworkPeriod: d.earthworkPeriod || '',
        soilLossReduction: d.soilLossReduction ?? '',
        updateTime: d.updateTime || '',
        processTime: d.processTime || d.applyTime || ''
      };
    },
    mapSoilInfoProduct(d) {
      const imageBaseUrl = 'https://qtzp.qhdbigdata.com/qtzp-api/upload/';
      const allFileNames = typeof d.imageUrl === 'string'
        ? d.imageUrl.split(',').map(s => s.trim()).filter(Boolean)
        : [];
      const allImgs = allFileNames.map(fn => (fn.startsWith('http') ? fn : imageBaseUrl + fn));
      const firstImg = allImgs[0] || '';
      return {
        id: d.id,
        viewCount: d.viewCount || 0,
        image: firstImg || this.product.image,
        images: allImgs.length > 0 ? allImgs : [firstImg || this.product.image],
        title: d.title || '',
        volume: d.volume || 0,
        volumeUnit: d.volumeUnit || '',
        address: d.address || '',
        soilType: d.soilType || '',
        contactPhone: d.contactPhone || '',
        longitude: d.longitude || null,
        latitude: d.latitude || null,
        detail: d.detail || '',
        supplyUnit: d.supplyUnit || d.supplySoilInfo?.supplyUnit || '',
        demandUnit: d.demandUnit || d.demandSoilInfo?.demandUnit || '',
        projectName: d.projectName || '',
        startTime: d.startTime || '',
        endTime: d.endTime || '',
        earthworkPeriod: '',
        soilLossReduction: '',
        updateTime: '',
        processTime: ''
      };
    },
    // 显示 Toast 提示
    showToastMessage(message, type = 'success') {
      this.toastMessage = message;
      this.toastType = type;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000); // 2秒后自动消失
    },
    // 切换手机号显示/隐藏
    async togglePhoneDisplay() {
      // console.log('点击查看按钮，showFullPhone:', this.showFullPhone, 'contactPhone:', this.product.contactPhone);
      
      // 如果当前是隐藏状态，点击"查看"时调用接口获取联系方式
      if (!this.showFullPhone) {
        // 防止重复请求
        if (this.contactLoading) {
          console.log('正在加载中，忽略重复请求');
          return;
        }
        
        try {
          this.contactLoading = true;
          const productId = this.id || this.product.id;
          // console.log('准备调用接口，productId:', productId);
          
          if (!productId) {
            // console.error('产品ID不存在');
            this.showToastMessage('产品ID不存在', 'error');
            this.contactLoading = false;
            return;
          }
          
          // console.log('调用 getContactInfo 接口，id:', productId);
          const res = await getContactInfo(productId);
          // console.log('获取联系方式接口返回:', res);
          
          // 处理返回数据，适配不同的返回格式
          // API返回格式: { code: 0, msg: "string", data: "string" }
          // data 字段就是手机号
          let contactPhone = '';
          if (res) {
            // 格式1: { data: "手机号" } - 标准格式
            if (res.data !== undefined && res.data !== null) {
              if (typeof res.data === 'string') {
                contactPhone = res.data;
              } else if (typeof res.data === 'object' && res.data.contactPhone) {
                contactPhone = res.data.contactPhone;
              }
            }
            // 格式2: 直接返回手机号字符串
            else if (typeof res === 'string') {
              contactPhone = res;
            }
            // 格式3: { contactPhone: "手机号" }
            else if (res.contactPhone) {
              contactPhone = res.contactPhone;
            }
          }
          
          // console.log('解析后的手机号:', contactPhone);
          
          if (contactPhone) {
            // 更新产品联系方式
            this.product.contactPhone = String(contactPhone);
            // 显示完整手机号
            this.showFullPhone = true;
            // console.log('成功获取联系方式，已显示完整手机号');
          } else {
            // console.warn('未返回有效数据，res:', res);
            this.showToastMessage('获取联系方式失败，未返回有效数据', 'error');
          }
        } catch (error) {
          // console.error('获取联系方式失败:', error);
          // console.error('错误详情:', {
          //   message: error?.message,
          //   response: error?.response,
          //   status: error?.response?.status,
          //   data: error?.response?.data
          // });
          const errorMsg = error?.response?.data?.msg || error?.message || '获取联系方式失败，请稍后再试';
          this.showToastMessage(errorMsg, 'error');
        } finally {
          this.contactLoading = false;
        }
      } else {
        // 如果当前是显示状态，点击"隐藏"时直接隐藏
        // console.log('隐藏手机号');
        this.showFullPhone = false;
      }
    },
    goBack() {
    
    },
    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve();
      }
      
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://webapi.amap.com/maps?v=2.0&key=6c995fc229d0e1ad8fa3f066161ee70a';
        script.onload = () => {
          // console.log('高德地图API加载完成');
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async initMap() {
      try {
        await this.loadAmapScript();
        
        // 初始化地图
        this.map = new window.AMap.Map('product-map', {
          zoom: 15,
          center: [this.landLocation.lng, this.landLocation.lat],
          mapStyle: 'amap://styles/normal',
          viewMode: '2D'
        });
        
        // 添加标记点 - 使用 iconfont 图标
        const marker = new window.AMap.Marker({
          position: [this.landLocation.lng, this.landLocation.lat],
          title: '土方位置',
          content: `<div style="position: relative;">
            <span class="iconfont icon-1" style="
              font-size: 40px; 
              color: #FF4757;
              text-shadow: 0 2px 4px rgba(0,0,0,0.3);
            "></span>
          </div>`,
          offset: new window.AMap.Pixel(-20, -40)
        });
        
        this.map.add(marker);
        
        // 添加信息窗体
        const infoWindow = new window.AMap.InfoWindow({
          content: `<div style="padding: 10px;">
            <h4 style="margin: 0 0 8px 0; color: #333;">${this.product.title}</h4>
            <p style="margin: 0; color: #666; font-size: 14px;">${this.product.address || '—'}</p>
          </div>`,
          offset: new window.AMap.Pixel(0, -50),
          anchor: 'bottom-center'
        });
        
        infoWindow.open(this.map, [this.landLocation.lng, this.landLocation.lat]);
        
        // 等地图加载完成后，使用 setFitView 自动调整视野
        this.map.on('complete', () => {
          // 设置合适的边距，确保标记点和信息窗体都完全显示
          this.map.setFitView([marker], false, [50, 150, 50, 50]);
        });
        
      } catch (error) {
        console.error('地图初始化失败:', error);
      }
    },
    async fetchDetail() {
      try {
        let d = null;
        
        // 如果是成功案例，调用 getWebSuccessCaseDetail 接口
        if (this.isFromSuccess) {
          const res = await getWebSuccessCaseDetail(this.id);
          d = this.parseSuccessCaseDetail(res, this.id);
        } else {
          // 普通详情，调用 getWebInfoDetail 接口
          const res = await getWebInfoDetail(this.id);
          d = res?.data || res;
        }
        
        if (d) {
          this.product = this.isFromSuccess
            ? this.mapSuccessCaseProduct(d)
            : this.mapSoilInfoProduct(d);
          this.currentImageIndex = 0;
          if (d.longitude && d.latitude) {
            this.landLocation = { lng: Number(d.longitude), lat: Number(d.latitude) };
          }
        }
      } catch (e) {
        console.error('获取详情失败:', e);
        this.showToastMessage('获取详情失败，请稍后再试', 'error');
      }
    },
    selectThumb(index) {
      this.currentImageIndex = index;
    },

    // 请求匹配 - 显示弹窗
    async addSoilApply() {
      // 验证参数
      if (!this.product.id) {
        this.showToastMessage('土方信息不存在', 'error');
        return;
      }
      
      // 打开弹窗
      this.showRequestMatchModal = true;
      this.selectedUnmatchedId = null;
      this.selectedSoilType = ''; // 重置土方类型选择
      // 不自动加载列表，等待用户选择土方类型后再加载
    },
    // 土方类型选择变化时重新加载列表
    async onSoilTypeChange() {
      if (this.selectedSoilType) {
        await this.loadUnmatchedList();
      } else {
        this.unmatchedList = [];
      }
    },
    // 加载可匹配的土方信息列表
    async loadUnmatchedList() {
      if (!this.product.id) {
        return;
      }
      
      // 如果未选择土方类型，不加载
      if (!this.selectedSoilType) {
        this.unmatchedList = [];
        return;
      }
      
      this.unmatchedListLoading = true;
      try {
        // 将前端的土方类型映射到接口期望的格式：'1'找土，'0'弃土
        let infoType = this.selectedSoilType;
        if (this.selectedSoilType === '2') {
          infoType = '0'; // 弃土类型：前端用'2'，接口用'0'
        }
        
        const res = await getMySoilInfoSmartUnmatched({
          // targetSoilId: this.product.id
          infoType: infoType
        });
        
        console.log('可匹配土方信息列表接口返回:', res);
        
        
        if (res) {
          // 格式1: { rows: [...] }
          if (res.rows && Array.isArray(res.rows)) {
            this.unmatchedList = res.rows || [];
            console.log('list:', this.unmatchedList);
          }
          
        }
        
      } catch (error) {
        console.error('获取可匹配土方信息列表失败:', error);
        const errorMsg = error?.response?.data?.msg || error?.message || '获取列表失败，请稍后再试';
        this.showToastMessage(errorMsg, 'error');
        this.unmatchedList = [];
      } finally {
        this.unmatchedListLoading = false;
      }
    },
    // 关闭请求匹配弹窗
    closeRequestMatchModal() {
      this.showRequestMatchModal = false;
      this.unmatchedList = [];
      this.selectedUnmatchedId = null;
      this.selectedSoilType = ''; // 重置土方类型选择
    },
    // 提交请求匹配
    async submitRequestMatch() {
      if (!this.selectedSoilType) {
        this.showToastMessage('请选择土方类型', 'error');
        return;
      }
      
      if (!this.selectedUnmatchedId) {
        this.showToastMessage('请选择要匹配的土方信息', 'error');
        return;
      }
      
      if (!this.product.id) {
        this.showToastMessage('土方信息不存在', 'error');
        return;
      }
      
      try {
        // 获取选中的土方信息的 applySoilId（申请人土方信息id）
        const selectedItem = this.unmatchedList.find(item => item.id === this.selectedUnmatchedId);
        if (!selectedItem) {
          this.showToastMessage('选择的土方信息不存在', 'error');
          return;
        }
        
        const applySoilId = selectedItem.id; // 申请人土方信息id
        
        const res = await addSoilApply({
          targetSoilId: this.product.id, // 土方id-被申请人id
          applySoilId: applySoilId // 申请人土方信息id
        });
        
        // 处理响应
        if (res && res.code === 200) {
          this.showToastMessage('新增土方匹配申请成功', 'success');
          this.closeRequestMatchModal();
        } else {
          // 如果响应中有错误信息，直接显示
          const errorMsg = res?.msg || res?.message || '申请失败，请稍后再试';
          this.showToastMessage(errorMsg, 'error');
        }
      } catch (error) {
        // 优先从 error.response.data 中获取错误信息
        let errorMsg = '申请失败，请稍后再试';
        
        if (error.response && error.response.data) {
          // 从响应数据中提取错误信息
          errorMsg = error.response.data.msg || error.response.data.message || errorMsg;
        } else if (error.message) {
          // 如果拦截器 reject 的 Error 对象包含 message
          errorMsg = error.message;
        }
        
        this.showToastMessage(errorMsg, 'error');
      }
    }
  },
  beforeUnmount() {
    // 清理地图实例
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  },
  mounted() {
    this.fetchDetail().then(() => {
      this.$nextTick(() => {
        this.initMap();
      });
    });
  }
};
</script>

<style scoped>
/* 引入iconfont.css */
@import url('../assets/iconfont.css');

.product-detail {
  background-color: white;
  padding:0 20px 20px 20px;

}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;

}

/* 返回按钮 */
.back-button {
  margin-bottom: 20px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #422C27;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.back-btn:hover {
  background-color: #0d7568;
}

.back-btn .iconfont {
  font-size: 16px;
}

/* 面包屑导航 */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;
}

.breadcrumb span:not(:last-child) {
  color: #422C27;
}

/* 主要内容区域 */
.container {
  display: flex;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;

}

.image-section {
  flex: 1;
}

.main-image {
  position: relative;
  margin-bottom: 15px;
}

.detail-img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;
}

.status-tag {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 3px;
  transform: rotate(-15deg);
  box-shadow: 0 4px 15px rgba(211, 47, 47, 0.4),
              inset 0 0 0 3px rgba(255, 255, 255, 0.3),
              inset 0 0 0 8px #d32f2f;
  border: 3px solid rgba(255, 255, 255, 0.5);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  animation: stamp-pulse 2s ease-in-out infinite;
  z-index: 10;
}

.status-tag::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px dashed rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
}

@keyframes stamp-pulse {
  0%, 100% {
    transform: rotate(-15deg) scale(1);
  }
  50% {
    transform: rotate(-15deg) scale(1.05);
  }
}

.image-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* padding: 0 15px; */
}

.nav-arrow {
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
}

.nav-arrow:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.3);
  font-size: 24px;
  font-weight: bold;
  pointer-events: none;
}

.image-thumbnails {
  display: flex;
  gap: 10px;
}

.thumbnail {
  width: 80px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
}

.thumbnail.active {
  border-color: #ff6b35;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右侧详情区域 */
.detail-section {
  flex: 1;
  padding-left: 20px;
}

.title-section {
  margin-bottom: 20px;
}

.detail-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.detail-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}

.meta-left {
  display: flex;
  gap: 20px;
  align-items: center;
}

.meta-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.land-code {
  color: #422C27;
  font-weight: bold;
}

.action-icons {
  display: flex;
  gap: 15px;
}

.action-icon {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.action-icon:hover {
  color: #422C27;
  border-color: #422C27;
}

.price-info {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.price-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.price-value {
  font-size: 40px;
  font-weight: bold;
  color: #ff6b35;
  margin-bottom: 10px;
}

.service-fee {
  font-size: 14px;
  color: #666;
}

.view-details {
  color: #422C27;
  cursor: pointer;
}

.land-attributes {
  margin-bottom: 20px;
}

.attribute-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.attr-label {
  color: #666;
  font-size: 14px;
  min-width: 120px;
  text-align: left;
}

.attr-value {
  color: #333;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.attr-value-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.view-phone-btn {
  padding: 4px 12px;
  background-color: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.view-phone-btn:hover:not(:disabled) {
  background-color: #E4CEC2;
  color: #333;
}

.view-phone-btn:disabled {
  background-color: #ccc;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.vip-section {
  background-color: #fff8e1;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vip-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vip-icon {
  background-color: #ff9800;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.vip-text {
  font-weight: bold;
  color: #ff9800;
}

.vip-desc {
  font-size: 14px;
  color: #666;
}

.recharge-btn {
  background-color: #ff9800;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.consultant-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
}

.consultant-info {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.consultant-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.consultant-details {
  flex: 1;
}

.consultant-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.consultant-role {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.consultant-phone {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #333;
}

.view-phone-btn {
  background-color: #422C27;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.callback-btn {
  flex: 1;
  background-color: #422C27;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  position: relative;
}

.free-tag {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4444;
  color: white;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 2px;
}

.contract-btn {
  flex: 1;
  background-color: #422C27;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.qr-section {
  text-align: center;
  margin-bottom: 15px;
}

.qr-code {
  width: 80px;
  height: 80px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-placeholder {
  color: #999;
  font-size: 12px;
}

.qr-text {
  font-size: 12px;
  color: #666;
}

.marketing-slogan {
  font-size: 12px;
  color: #422C27;
  text-align: center;
  cursor: pointer;
}

.marketing-slogan:hover {
  text-decoration: underline;
}

/* 地图位置区域 */
.map-section {
  width:1200px;
  margin: 40px auto 0;
  padding: 30px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #422C27;
}

.map-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.map-title .iconfont {
  color: #422C27;
  font-size: 28px;
}

.map-address {
  color: #666;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.map-container {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
}

.product-amap {
  width: 100%;
  height: 100%;
}

.map-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: 
    linear-gradient(rgba(14, 133, 117, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(14, 133, 117, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
}

.map-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #422C27 0%, #0d6b5f 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(14, 133, 117, 0.3);
  animation: map-bounce 2s ease-in-out infinite;
}

.map-icon .iconfont {
  font-size: 40px;
  color: white;
}

@keyframes map-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.map-text {
  font-size: 18px;
  color: #666;
  margin: 10px 0;
}

.map-coords {
  font-size: 14px;
  color: #999;
  font-family: monospace;
}

.map-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.map-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 30px;
  background: linear-gradient(135deg, #422C27 0%, #0d6b5f 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(14, 133, 117, 0.3);
}

.map-btn:hover {
  background: linear-gradient(135deg, #0d6b5f 0%, #0c5a4f 100%);
  box-shadow: 0 6px 16px rgba(14, 133, 117, 0.4);
  transform: translateY(-2px);
}

.map-btn .iconfont {
  font-size: 18px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .detail-content {
    flex-direction: column;
  }
  
  .detail-section {
    padding-left: 0;
    margin-top: 20px;
  }
  
  .detail-meta {
    flex-direction: column;
    gap: 10px;
  }

  .map-section {
    margin: 20px 10px;
    padding: 20px;
  }

  .map-container {
    height: 300px;
  }

  .map-actions {
    flex-direction: column;
  }

  .map-btn {
    width: 100%;
    justify-content: center;
  }
}

/* 请求匹配弹窗样式 */
.request-match-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.request-match-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.request-match-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.request-match-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.request-match-modal-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  min-height: 200px;
}

/* 土方类型选择器样式 */
.soil-type-selector {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.selector-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}

.radio-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: color 0.3s ease;
}

.radio-option:hover {
  color: #422C27;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #422C27;
  margin: 0;
}

.radio-option span {
  user-select: none;
}

.loading-text,
.empty-text {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 14px;
}

.unmatched-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.unmatched-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.unmatched-item:hover {
  border-color: #422C27;
  background: #f8f9fa;
}

.unmatched-item.active {
  border-color: #422C27;
  background: #f0f7ff;
  box-shadow: 0 2px 8px rgba(66, 44, 39, 0.1);
}

.unmatched-radio {
  flex-shrink: 0;
  margin-top: 2px;
}

.unmatched-radio input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #422C27;
}

.unmatched-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.unmatched-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.unmatched-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.unmatched-detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.request-match-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.cancel-btn,
.submit-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn {
  background: #f0f0f0;
  color: #666;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.submit-btn {
  background: #422C27;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background: #E4CEC2;
  color: #333;
}

.submit-btn:disabled {
  background: #ccc;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .request-match-modal-content {
    width: 95%;
    max-width: 95%;
  }

  .unmatched-item {
    padding: 12px;
  }

  .unmatched-detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .detail-label {
    min-width: auto;
  }
}

/* Toast 提示框样式 */
.success-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  pointer-events: none;
}

.toast-content {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  min-width: 150px;
  justify-content: center;
}

.toast-content.toast-error {
  background: rgba(211, 47, 47, 0.9);
}

.toast-icon {
  font-size: 20px;
  color: #4caf50;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(76, 175, 80, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
}

.toast-error-icon {
  color: #fff;
  background: rgba(255, 255, 255, 0.3);
}

.toast-message {
  font-size: 16px;
  font-weight: 500;
}

/* 提示框淡入淡出动画 */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}
</style>
